import { FC } from 'react';
import illustration from '@svg/illustrations/success_order_card.svg';
import Typography from '@components/common/typography';
import styles from './styles.module.scss';
import Button from '@components/common/button';
import { useNavigate } from 'react-router-dom';
import { routes } from '@const/routes';
import { ECardType } from '@xeppt/xeppt-sdk/types/card';
import { prettifyCardType } from '@utils/index';
import { useLocales } from '@hooks/helpers/useLocales';

interface IProps {
    cardType?: ECardType;
}

const SuccessStep: FC<IProps> = ({ cardType }) => {
    // const { t } = useTranslation('sections', {
    //     keyPrefix: 'order_card.success'
    // });
    const navigate = useNavigate();
    const { submitLocale } = useLocales();
    return (
        <div className={styles.wrapper}>
            <img src={illustration} alt="" />
            <Typography className={styles.title} variant="body1" alignment="center">
                Success!
            </Typography>
            <p className={styles.description}>
                Your XEPPT {prettifyCardType(cardType)} card order has been submitted. It will
                arrive within 9 business days.
            </p>
            <Button variant="primary" onClick={() => navigate(routes.dashboard)}>
                {submitLocale('done')}
            </Button>
        </div>
    );
};

export default SuccessStep;
